<template>
  <div id="contenedor-infraestructura-listado-configuracion-caracteristicas-subtipos-infraestructura">
    <template v-if="!$vuetify.breakpoint.mobile">
      <desktop
      :listadoCaracteristciasSubtipoInfraestructura="listadoCaracteristciasSubtipoInfraestructura">
      </desktop>
    </template>
    <template v-else>
      <desktop
      :listadoCaracteristciasSubtipoInfraestructura="listadoCaracteristciasSubtipoInfraestructura">
      </desktop>
    </template>
  </div>
</template>

<script>
import Desktop from './Desktop.vue';
// import Mobile from './Mobile.vue';

export default {
  name: 'InfraestructuraListadoConfiguracionCaracteristicasSubtipoInfraestructura',
  props: {
    listadoCaracteristciasSubtipoInfraestructura: {
      type: Array,
      required: true,
    },
  },
  components: {
    Desktop,
    // Mobile,
  },
  data() {
    return {};
  },
};
</script>

<style lang="scss"></style>
